import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=0d474c5b&scoped=true"
import script from "./page9.vue?vue&type=script&lang=js"
export * from "./page9.vue?vue&type=script&lang=js"
import style0 from "./page9.vue?vue&type=style&index=0&id=0d474c5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d474c5b",
  null
  
)

export default component.exports